import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { TravelIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTripGrouping } from '../../api/trip-groupings/create-trip-grouping'
import UserNavBar from '../../components/elements/nav-bar'
import { TripGroupingForm } from '../../components/pages/trip-groupings/trip-grouping-form'
import { Paths } from '../../lib/constants/path'
import { twoButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'

export function TripGroupingCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createTripGrouping,
    onError: showAxiosError,
    onSuccess: () => toast.success('Groupe de voyage créé avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer un groupe de voyage'} icon={TravelIcon} />
      <div className={'h-4'} />

      <Box>
        <TripGroupingForm
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.TRIP_GROUPING_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back(Paths.TRIP_GROUPING_LIST_PAGE)
          })}
        />
      </Box>
    </div>
  )
}
